import type { NotebookItemJSON } from './types'

export type TNotebookState = {
    notebookItems: NotebookItemJSON[]
    experimentEndDate: Date
}

export const getInitialNotebookState = (): TNotebookState => {
    return {
        experimentEndDate: new Date('2026-12-13T00:00:00.000Z'),
        notebookItems: [],
    }
}

const moduleState = getInitialNotebookState()

export default moduleState
